// extracted by mini-css-extract-plugin
export default {"wrapper":"iga","container":"jga","image":"kga","info":"lga","title":"mga","note":"nga","product":"oga","product_img":"pga","description":"qga","name":"rga","whybtn":"sga","buttons":"tga"};
    if(module.hot) {
      // 1730991513156
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  